const a = (t) => Object.values(t).some(
  (s) => Array.isArray(s) ? s.length > 0 : a(s)
);
export {
  a as hasErrors
};
